import React from "react";
import NuAmount from "../../../../Components/Utils/NuAmount";
import Info from "../../../../Components/Icons/Info";
import { CalPercentageSelling } from "../../../../Components/Utils/OtherFuction";
import { formatDisplaySno } from "../../../../Components/Utils/formatDisplaySno";
function TempCom({ label = "", value = 0, calculation = 0 }) {
  return (
    <tr className="w-full">
      <td className="w-[140px] py-1">{label}</td>
      <td className="w-[10px] py-1">:</td>
      <td className="min-w-[130px] py-1">
        {value}
        {label === "Duty" && calculation !== null && (
          <span>
            {" ("}
            <NuAmount value={calculation} />
            {")"}
          </span>
        )}
      </td>
    </tr>
  );
}

const InfoTooltip = ({ supplier }) => {
  const [show, setShow] = React.useState(false);
  const [pos, setPos] = React.useState({ top: 0, left: 0, placeAbove: false });
  const triggerRef = React.useRef(null);

  const handleMouseEnter = () => {
    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const placeAbove = spaceBelow < 250;
      setPos({
        top: placeAbove ? rect.top - 8 : rect.bottom + 8,
        left: Math.max(10, Math.min(window.innerWidth - 365, rect.left - 150)),
        placeAbove,
      });
      setShow(true);
    }
  };

  return (
    <div
      ref={triggerRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setShow(false)}
      className="cursor-pointer inline-block"
    >
      <span>
        <Info />
      </span>
      {show && (
        <div
          className="fixed z-[999999] font-medium border border-teal-700 bg-white text-xs rounded-lg p-2 shadow-2xl min-w-[350px] text-black pointer-events-none"
          style={{
            top: `${pos.top}px`,
            left: `${pos.left}px`,
            transform: pos.placeAbove ? "translateY(-100%)" : "none",
          }}
        >
          <table className="text-left border-collapse w-full">
            <TempCom
              label="Supplier Price"
              value={`${supplier?.currencyLabel || ""} ${supplier?.unitPrice || "0"}`}
            />
            <TempCom
              label="Converted Price"
              value={<NuAmount value={supplier?.convertedPrice || "0"} />}
            />
            <TempCom
              label="Duty"
              value={`${supplier?.dutty || "0"}%`}
              calculation={
                supplier?.dutty && supplier?.convertedPrice
                  ? ((supplier?.convertedPrice / 100) * supplier?.dutty).toFixed(2)
                  : null
              }
            />
            <TempCom
              label="Trans. + Exp"
              value={<NuAmount value={supplier?.trans || "0"} />}
            />
            <TempCom
              label="Landing Cost"
              value={<NuAmount value={supplier?.landedCost || "0"} />}
            />
            <TempCom
              label="Final Unit Price"
              value={<NuAmount value={supplier?.LCSP || "0"} />}
            />
          </table>
        </div>
      )}
    </div>
  );
};

const QuoteComparisonTable = ({
  supplierList = [],
  dynamicHeaders = null,
  datas = [],
  stateValue = [],
  latestCqProducts = [],
  isEdit = false,
  gPEditShow = false,
  ClickProducts = () => false,
  handleChange = () => { },
  handleGPChange = () => { },
}) => {
  return (
    <div
      className={
        supplierList?.length > 10
          ? `w-[calc((100vw-300px)*4.9)]`
          : supplierList?.length > 6
            ? `w-[calc((100vw-300px)*3.9)]`
            : supplierList?.length > 4
              ? `w-[calc((100vw-300px)*2.9)]`
              : supplierList?.length > 1
                ? `w-[calc((100vw-300px)*1.8)]`
                : supplierList?.length === 1
                  ? `w-[calc((100vw-300px))]`
                  : `w-full overflow-x-scroll relative`
      }
    >

      <table className="table-auto relative border-collapse border border-slate-300 z-0">
        <thead className="bg-baseColor-primary sticky top-0 text-white text-xs 2xl:text-sm z-30">
          <tr>
            <th
              colSpan={3}
              className="w-[580px] py-1 lg:sticky left-0 bg-baseColor-primary z-40 border-r border-slate-400"
            >
              <div className="flex w-full h-[85px] items-center">
                <div className="w-[80px] h-full flex justify-center items-center text-center border-r border-[#acaaaa]">
                  S.N
                </div>
                <div className="w-[300px] h-full flex justify-center items-center text-left border-r border-[#acaaaa]">
                  Product
                </div>
                <div className="w-[100px] h-full flex justify-center items-center text-right border-r border-[#acaaaa]">
                  Unit
                </div>
                <div className="w-[100px] h-full flex justify-center items-center text-right pr-1">
                  Qty
                </div>
              </div>
            </th>

            {dynamicHeaders}
          </tr>
        </thead>
        <tbody>
          {datas &&
            datas.map((item, idx) => (
              <tr
                key={idx}
                className="odd:bg-white even:bg-slate-50 text-xs 2xl:text-sm border-collapse border border-slate-300"
              >
                <td
                  colSpan={supplierList?.length >= 1 ? 3 : 0}
                  className={`w-[580px] h-full text-center lg:sticky left-0 ${idx % 2 !== 0 ? "bg-slate-50" : "bg-white"
                    } z-20`}
                >

                  <div className="flex items-stretch h-full ">
                    <div className="w-[80px] text-center border-r border-[#acaaaa] flex justify-center items-center py-2">

                      {item.display_sno || item.sno || item.sNo}
                    </div>
                    <div className="w-[300px] text-left line-clamp-2  border-r border-[#acaaaa] flex justify-start px-2 items-center">
                      <div>
                        <p>{item.name}</p>
                        {item.alternate === true && (
                          <p className="text-green-500 w-[90px] rounded-md font-normal text-[8px]">
                            Alternate Item
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="w-[100px] text-center  border-r border-[#acaaaa] flex justify-center items-center">
                      {item.unit}
                    </div>
                    <div className="w-[100px] text-center pr-1  flex justify-center items-center">
                      {item.requestedQty}
                    </div>
                  </div>
                </td>

                {supplierList.map((sub, index) => {
                  const supplier = stateValue.find(
                    (i) =>
                      i.productId === item.id &&
                      i.quoteId === sub.quoteId,
                  );
                  if (supplier) {
                    const isLatestCqSelected = latestCqProducts?.some(
                      (l) =>
                        (l.supQuotProductId &&
                          (String(l.supQuotProductId) === String(supplier.id) ||
                            String(l.supQuotProductId) === String(supplier.supQuotProductId))) ||
                        (l.productId === item.id &&
                          Number(l.price) === Number(supplier.unitPrice || supplier.LCSP) &&
                          (l.sno === item.sno || l.sno === item.display_sno))
                    );
                    return (
                      <React.Fragment
                        key={`dynamic-cell-${idx}-${index}`}
                      >
                        <td className="w-[500px]">
                          <div className="w-full flex h-full items-stretch">
                            <td
                              className="py-2 text-center border-collapse border-x border-y-0 w-[200px] border-slate-300"
                            >
                              <div className="flex justify-center text-center items-center gap-1.5">
                                {isLatestCqSelected && (
                                  <span
                                    title={
                                      isEdit
                                        ? "Selected in Previous Customer Quotation"
                                        : "Selected in Latest Customer Quotation"
                                    }
                                    className="inline-block w-2 h-2 rounded-full bg-blue-500 shrink-0 shadow-xs"
                                  />
                                )}

                                <InfoTooltip supplier={supplier} />

                                <input
                                  type="checkbox"
                                  checked={supplier.isSelected}
                                  disabled={ClickProducts(supplier)}
                                  onChange={(e) =>
                                    handleChange(
                                      e,
                                      supplier.quoteId,
                                      supplier.productId,
                                    )
                                  }
                                />
                                {supplier?.LCSP
                                  ? parseFloat(
                                    supplier.LCSP,
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })
                                  : "-"}
                              </div>
                              <div className="text-[10px] text-gray-500">
                                {supplier?.leadTime || "Lead Time : None"}
                              </div>
                            </td>
                            <td
                              className="py-2 text-center border-collapse border-x border-y-0 w-[100px] border-slate-300"
                            >
                              <div className="w-full h-full flex justify-evenly px-1">
                                <input
                                  type="number"
                                  placeholder="0"
                                  className={`w-full py-1 px-2 text-center focus:outline-none rounded border transition-all ${gPEditShow
                                    ? "cursor-pointer border-gray-400 bg-amber-50/50 text-gray-900 font-semibold ring-1 ring-gray-400"
                                    : "cursor-not-allowed border-slate-300 bg-slate-100 text-gray-500 opacity-80"
                                    }`}
                                  value={
                                    gPEditShow === true
                                      ? parseFloat(supplier.gp) > 0
                                        ? parseFloat(supplier.gp)
                                        : ""
                                      : parseFloat(supplier.gp)
                                  }
                                  onChange={(e) =>
                                    handleGPChange(
                                      e,
                                      supplier.quoteId,
                                      supplier.productId,
                                    )
                                  }
                                  disabled={gPEditShow !== true}
                                />
                              </div>
                            </td>
                            <td
                              className={`flex flex-col justify-center py-1 text-center border-collapse border-x border-y-0 w-[200px] ${supplier.isLow === true && supplier.isHigh === true
                                ? "bg-green-100"
                                : supplier.isHigh === true &&
                                  supplier?.sellingPrice > 0
                                  ? "bg-red-100"
                                  : supplier.isLow === true &&
                                    supplier?.sellingPrice > 0
                                    ? "bg-green-100"
                                    : ""
                                } border-slate-300`}
                            >
                              <div className="w-full">
                                <NuAmount
                                  value={supplier?.sellingPrice || 0}
                                />
                              </div>
                              <div className="text-[10px] text-gray-500">
                                Total :{" "}
                                <NuAmount
                                  value={
                                    parseFloat(supplier?.sellingPrice) *
                                    parseFloat(item.requestedQty) || 0
                                  }
                                />
                                {supplier.isLow !== true &&
                                  supplier?.sellingPrice > 0 && (
                                    <span className="ml-1 w-full text-[10px] text-red-700 truncate">
                                      {CalPercentageSelling(
                                        stateValue,
                                        supplier,
                                        item?.name,
                                      )}
                                    </span>
                                  )}
                              </div>
                            </td>
                          </div>
                        </td>
                      </React.Fragment>
                    );
                  } else {
                    return (
                      <React.Fragment
                        key={`dynamic-cell-${idx}-${index}`}
                      >
                        <td className="border-collapse border-x border-y-0 border-slate-300 text-center">
                          {" "}
                          -{" "}
                        </td>
                      </React.Fragment>
                    );
                  }
                })}
              </tr>
            ))}
          <tr className="bg-white text-xs 2xl:text-sm font-bold">
            <td
              colSpan={3}
              className="py-2 text-center lg:sticky left-0 bg-white z-[0] border-t"
            ></td>

            {supplierList.map((sub, supplierIndex) => {
              const totalPrice = stateValue
                .filter((i) => i.quoteId === sub.quoteId)
                .reduce(
                  (total, supplier) =>
                    total +
                    parseFloat(supplier.sellingPrice || 0) *
                    parseFloat(supplier?.requestedQty || 0),
                  0,
                );

              return (
                <React.Fragment key={`total-row-${supplierIndex}`}>
                  <td className="w-[500px]">
                    <div className="w-full flex">
                      <td className="py-2 text-center w-[200px]" />
                      <td className="py-2 text-center w-[100px]" />
                      <td className="py-2 text-center w-[200px] px-2">
                        <div className="flex gap-2 text-[10px] text-gray-500 justify-center">
                          <span>Total:</span>
                          <NuAmount value={totalPrice} />
                        </div>
                      </td>
                    </div>
                  </td>
                </React.Fragment>
              );
            })}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default QuoteComparisonTable;
